"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "caption1StrongClassNames", {
    enumerable: true,
    get: function() {
        return _useCaption1StrongStylesstyles.caption1StrongClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Caption1Strong"), exports);
const _useCaption1StrongStylesstyles = require("./useCaption1StrongStyles.styles");
